import Link from 'next/link'
import { CheckCircle2 } from 'lucide-react'
import { RevealWrapper } from '../components/RevealWrapper'

const SIGNUP_URL = '/auth/login'

const PLAN_FEATURES = [
  'Clientes e áreas ilimitados',
  'Agenda de serviços completa',
  'Dashboard financeiro',
  'App do piloto para o campo',
  'Calculadora de calda',
  'Relatórios para o cliente',
  'Suporte no WhatsApp',
  'Atualizações inclusas',
]

export function PricingSection() {
  return (
    <section
      aria-labelledby="pricing-heading"
      style={{ padding: '72px 24px', maxWidth: 480, margin: '0 auto' }}
    >
      <RevealWrapper>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <span
            style={{
              display: 'inline-block',
              padding: '4px 12px',
              borderRadius: 999,
              background: '#EEF8F2',
              color: '#1A5C2E',
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '0.05em',
              textTransform: 'uppercase',
              marginBottom: 16,
            }}
          >
            Plano único · sem surpresas
          </span>

          <h2
            id="pricing-heading"
            style={{
              fontFamily: 'var(--font-bricolage)',
              fontSize: 'clamp(22px, 7vw, 28px)',
              fontWeight: 800,
              lineHeight: 1.2,
              letterSpacing: '-0.025em',
            }}
          >
            Quanto custa perder um cliente
            <br />por falta de organização?
          </h2>
        </div>
      </RevealWrapper>

      <RevealWrapper delay={0.1}>
        <div
          style={{
            background: '#0B1D11',
            borderRadius: 28,
            padding: '36px 28px',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <div
            aria-hidden
            style={{
              position: 'absolute',
              top: -40, right: -40,
              width: 240, height: 240,
              background: 'radial-gradient(circle, rgba(82,201,126,0.13) 0%, transparent 70%)',
              pointerEvents: 'none',
            }}
          />

          <div style={{ position: 'relative', zIndex: 1 }}>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.38)', marginBottom: 4 }}>
              Plano Profissional
            </p>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 4 }}>
              <span style={{ fontSize: 16, color: '#52C97E', fontWeight: 700 }}>R$</span>
              <span
                style={{
                  fontFamily: 'var(--font-bricolage)',
                  fontSize: 60,
                  fontWeight: 800,
                  color: '#fff',
                  lineHeight: 1,
                  letterSpacing: '-0.04em',
                }}
              >
                99
              </span>
              <span style={{ fontSize: 14, color: 'rgba(255,255,255,0.35)', marginLeft: 2 }}>
                /mês
              </span>
            </div>
            <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.32)', marginBottom: 30 }}>
              Menos de R$3,30 por dia para ter controle total.
            </p>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '12px 16px',
                marginBottom: 32,
              }}
            >
              {PLAN_FEATURES.map((feat, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <CheckCircle2 size={14} color="#52C97E" strokeWidth={2} style={{ flexShrink: 0 }} />
                  <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.72)' }}>{feat}</span>
                </div>
              ))}
            </div>

            <Link
              href={SIGNUP_URL}
              style={{
                display: 'block',
                background: '#3A8C56',
                color: '#fff',
                padding: '16px',
                borderRadius: 14,
                fontWeight: 700,
                fontSize: 15,
                fontFamily: 'var(--font-jakarta)',
                textAlign: 'center',
                textDecoration: 'none',
                boxShadow: '0 4px 24px rgba(58,140,86,0.38)',
              }}
            >
              Começar agora →
            </Link>
          </div>
        </div>
      </RevealWrapper>
    </section>
  )
}
